import { Component, computed, inject, signal, OnDestroy, input } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { QaiBadgeComponent, QaiCarouselComponent, QaiIconComponent, QaiCarouselItemDirective, QaiCallCaptionsComponent, QaiCallAudioIndicatorComponent } from '@qai/ui';

import { ICallDetailModal } from 'src/app/interfaces/icall-detail-modal';
import { parseTabText, ContentBlock } from 'src/app/utils/parse-tab-text';
import { injectAiNotice } from 'src/app/pages/learner/call/library/ai-notice/ai-notice';
import { AvatarPlayerDirective } from 'src/app/directives/avatar-player.directive';
import { RealtimeService } from '../../library/realtime/realtime.service';

@Component({
  selector: 'app-call-preamble',
  standalone: true,
  imports: [QaiBadgeComponent, QaiCarouselComponent, QaiIconComponent, QaiCarouselItemDirective, QaiCallCaptionsComponent, QaiCallAudioIndicatorComponent, AvatarPlayerDirective],
  templateUrl: './call-roleplay-preamble.component.html',
  styleUrls: ['./call-roleplay-preamble.component.scss'],
})
export class CallPreambleComponent implements OnDestroy {
  // The account's AI notice in the sim's or learner's language; null hides it.
  protected readonly aiNotice = injectAiNotice();

  readonly callDetails = input<ICallDetailModal | null>(null);
  readonly captionsOn = input<boolean>(false);
  readonly captionText = input<string>('');
  readonly realtimeService = input<RealtimeService | undefined>(undefined);
  readonly isMobile = signal(false);
  readonly avatarVideoPlaying = signal(false);
  readonly avatarVideoErrored = signal(false);
  private readonly breakpointSub: Subscription;
  readonly cardWidthPx = signal(0);

  constructor() {
    const bp = inject(BreakpointObserver);
    this.breakpointSub = bp.observe('(max-width: 768px)').subscribe((state) => {
      this.isMobile.set(state.matches);
    });
  }

  ngOnDestroy(): void {
    this.breakpointSub.unsubscribe();
  }

  readonly parsedTabs = computed(() =>
    [...(this.callDetails()?.callDetails ?? [])]
      .filter((tab) => tab.tabTitle?.trim() && tab.tabText?.trim())
      .sort((a, b) => a.tabSequence - b.tabSequence)
      .map((tab) => ({
        ...tab,
        blocks: parseTabText(tab.tabText),
      })),
  );

  protected handleAvatarVideoPlaying(): void {
    this.avatarVideoPlaying.set(true);
    this.avatarVideoErrored.set(false);
  }

  protected handleAvatarVideoError(): void {
    this.avatarVideoErrored.set(true);
    this.avatarVideoPlaying.set(false);
  }
}